<div class="mb-3 flex items-center gap-4" [formGroup]="formSearch">
  <mat-form-field class="input-tg mt-message-input w-2/12" appearance="outline">
    <mat-label>Pesquisar por</mat-label>
    <mat-select formControlName="searchType">
      @for (type of listType; track type) {
        <mat-option [value]="type.id">{{ type.description }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="input-tg search-tg mt-message-input w-7/12"
    appearance="outline"
  >
    <mat-label>Pesquisa</mat-label>
    <input matInput formControlName="search" />
  </mat-form-field>
  <mat-form-field class="input-tg mt-message-input w-2/12" appearance="outline">
    <mat-label>Status</mat-label>
    <mat-select formControlName="active">
      @for (item of listActive; track item) {
        <mat-option [value]="item.value">{{ item.description }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="w-1/12 flex justify-around">
    <button
      class="btn-icon"
      (click)="sendSearch(true)"
      [matTooltip]="'Pesquisa'"
    >
      <!--      [disabled]="this.formSearch.get('search')?.value == ''"-->
      <!--      [ngClass]="this.formSearch.get('search')?.value != '' ? '' : 'disabled'"-->
      <!--      <button-->
      <!--        class="btn-icon"-->
      <!--        (click)="sendSearch(true)"-->
      <!--        [disabled]="!checkForm()"-->
      <!--        [ngClass]="checkForm() ? '' : 'disabled'"-->
      <!--        [matTooltip]="'Pesquisa'"-->
      <!--      >-->
      <mat-icon>search</mat-icon>
    </button>
    <button
      class="btn-icon"
      (click)="sendSearch()"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
  </div>
</div>
